import gql from 'graphql-tag';

export const MUTATION_EDIT_NOTES = gql`
  mutation MUTATION_EDIT_NOTES($input: UpsertOpportunityReconciliationNoteInput) {
    upsertOpportunityReconciliationNote(input: $input) {
      result
    }
  }
`;
